import {Component, OnInit} from '@angular/core';
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Funcoes} from "../funcoes";
import {LoginService} from "app/login/login.service";
import {CertificadosNacionaisModel} from "./certificados-nacionais.model";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MercadoInternoMercadoriasService} from "../mercado-interno-mercadorias/mercado-interno-mercadorias.service";
import {BasicValidators} from "../shared/basic-validators";
import {CertificadosNacionaisService} from './certificados-nacionais.service';
import {ClientesService} from '../clientes/clientes.service';
import {TiposClientesService} from '../clientes/tipos-clientes.service';
import {TerminaisNacionaisService} from '../terminais-nacionais/terminais-nacionais.service';

declare let swal, $: any;

@Component({
  selector: 'app-certificados-nacionais',
  templateUrl: './certificados-nacionais.component.html'
})
export class CertificadosNacionaisComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  formSolicitarCertificado: FormGroup;
  solicitaCertificado = {"id_certificado_nacional": null, "email": ""};

  filtroPesquisa = {"status_pesquisa": "", "data_de":"", "data_ate":"", "numero":"", "numero_analise": "", "id_cliente":"", "id_mercadoria":"", "id_local_ingresso": "", "lote": ""};

  certificados: CertificadosNacionaisModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  podeFaturar = false;

  listStatus = [];
  listMercadorias = [];
  listClientes = [];
  listTerminais = [];
  certificadosSelecionados = [];

  checkAll = false;

  mesAtual;

  constructor(
    formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private certificadosService: CertificadosNacionaisService,
    private mercadoriasService: MercadoInternoMercadoriasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    public loginService: LoginService,
    private clientesService: ClientesService,
    private tiposClientesService: TiposClientesService,
    private terminaisNacionaisService: TerminaisNacionaisService
  ) {
    super();

    this.mesAtual = new Date();
    this.mesAtual = new Date(this.mesAtual.getFullYear(), this.mesAtual.getMonth(), 1).setHours(0,0,0,0);

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        const p = data.privilegios[i];
        const acaoUrl = (p.acao && p.acao[0] && p.acao[0].url) ? p.acao[0].url : '';
        const idAcao = String(p.id_acao || '');

        if(idAcao === '20' || acaoUrl === 'certificados-nacionais' || acaoUrl === 'prestacao-mapa' || acaoUrl === 'mercado-interno'){
          this.privilegioUsuario.consultar = p.consultar;
          this.privilegioUsuario.editar = p.editar;
        }else if(acaoUrl == 'financeiro'){
          this.podeFaturar = p.editar;
        }
      }
      if(this.func.userIsMaster()){
        this.privilegioUsuario.consultar = true;
        this.privilegioUsuario.editar = true;
      }
    });


    this.formPesquisaAvancada = formBuilder.group({
      data_de: [],
      data_ate: [],
      id_cliente: [],
      id_mercadoria: [],
      id_local_ingresso: [],
      numero: [],
      numero_analise: [],
      lote: [],
      status_pesquisa: []
    });

    this.formSolicitarCertificado = formBuilder.group({
      id_certificado_nacional: [],
      email: ['', [
        Validators.required,
        BasicValidators.email
      ]]
    });

    this.listStatus = this.func.nomesStatusCertificado();

    this.mercadoriasService.get()
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;

          if(this.global.debug == true){
            console.log(json.Payload);
          }
        },
        error => {
          this.func.showErro(error.json());
        });

    this.terminaisNacionaisService.get()
      .subscribe(
        json => {
          this.listTerminais = json.Payload;

          if(this.global.debug == true){
            console.log(json.Payload);
          }
        },
        error => {
          this.func.showErro(error.json());
        });
  }

  ngOnInit() {
    if (localStorage.hasOwnProperty("filtroPesquisa-certificados-nacionais")) {
      this.filtroPesquisa = JSON.parse(localStorage.getItem('filtroPesquisa-certificados-nacionais'));
    }

    switch (this.router.url.split(/\//).pop()) {
      case 'em-processamento':
        this.filtroPesquisa.status_pesquisa = "1";
        break;
      case 'emitidos':
        this.filtroPesquisa.status_pesquisa = "10";
        break;
      default:
        this.filtroPesquisa.status_pesquisa = "";
    }

    this.getPage(1);

    this.listStatus = this.func.nomesStatusCertificado();

    this.tiposClientesService.get(["clientes"])
      .subscribe(
        json => {
          this.listClientes = [];
          let clientesMercadoInterno = [];
          if (json.Payload) {
            json.Payload.forEach(tipo => {
              const nome = (tipo.nome_pt || tipo.nome_en || tipo.nome_es || '').toLowerCase();
              if (nome.indexOf('mercado interno') !== -1 && tipo.clientes) {
                clientesMercadoInterno = clientesMercadoInterno.concat(tipo.clientes);
              }
            });
          }
          const merged = this.func.mergeObjByProp([], clientesMercadoInterno, 'id_cliente');
          for (let i in merged) {
            this.listClientes.push({
              "id_cliente": merged[i].id_cliente,
              "nome": merged[i].nome_tratamento + ' (' + (merged[i].estado || '') + ') ' + (merged[i].cnpj || '')
            });
          }
        },
        error => {
          this.func.showErro(error.json());
        });


    this.mercadoriasService.get()
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;

          if(this.global.debug == true){
            console.log(json.Payload);
          }
        },
        error => {
          this.func.showErro(error.json());
        });

    this.terminaisNacionaisService.get()
      .subscribe(
        json => {
          this.listTerminais = json.Payload;

          if(this.global.debug == true){
            console.log(json.Payload);
          }
        },
        error => {
          this.func.showErro(error.json());
        });
  }

  delete(certificado) {

    let certificados = this.certificados;
    let certificadosService = this.certificadosService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarCertificado')+certificado.numero,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){

        if(self.global.debug == true){
          console.log(certificados);
        }

        let index = certificados.indexOf(certificado);
        certificados.splice(index, 1);

        certificadosService.apagar(certificado.id_certificado_nacional)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.certificados = certificados;
            },
            err => {
              // Revert the view back to its original state
              certificados.splice(index, 0, certificado);
              self.certificados = certificados;

              self.func.showErro(err.json());
            });

      });

  }

  // altera a quantidade de itens por pagina
  qtdItensPorPagina(event){
    this.itensPorPagina = event.target.value;
    localStorage.setItem('itensPorPagina', event.target.value);
    this.getPage(1);
  }

  getPage(pagina, salvaPesquisa = false){

    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if(this.filtroPesquisa.status_pesquisa != '' && this.filtroPesquisa.status_pesquisa != null){
      filtros['status_certificado'] = this.filtroPesquisa.status_pesquisa;
    }

    if(this.filtroPesquisa.data_de != '' && this.filtroPesquisa.data_de != null && this.filtroPesquisa.data_ate != '' && this.filtroPesquisa.data_ate != null){
      filtros['data_emissao'] = 'bt:'+this.filtroPesquisa.data_de+'|'+this.filtroPesquisa.data_ate;
    }else{
      if(this.filtroPesquisa.data_de != '' && this.filtroPesquisa.data_de != null){
        filtros['data_emissao'] = 'ge:'+this.filtroPesquisa.data_de;
      }

      if(this.filtroPesquisa.data_ate != '' && this.filtroPesquisa.data_ate != null){
        filtros['data_emissao'] = 'le:'+this.filtroPesquisa.data_ate;
      }
    }

    if(this.filtroPesquisa.numero != '' && this.filtroPesquisa.numero != null){
      filtros['numero'] = this.filtroPesquisa.numero;
    }

    if(this.filtroPesquisa.numero_analise != '' && this.filtroPesquisa.numero_analise != null){
      filtros['numero_analise'] = this.filtroPesquisa.numero_analise;
    }

    if(this.filtroPesquisa.id_cliente != '' && this.filtroPesquisa.id_cliente != null){
      filtros['id_cliente'] = this.filtroPesquisa.id_cliente;
    }

    if(this.filtroPesquisa.id_mercadoria != '' && this.filtroPesquisa.id_mercadoria != null){
      filtros['id_mercadoria'] = this.filtroPesquisa.id_mercadoria;
    }

    if(this.filtroPesquisa.id_local_ingresso != '' && this.filtroPesquisa.id_local_ingresso != null){
      filtros['id_local_ingresso'] = this.filtroPesquisa.id_local_ingresso;
    }

    if(this.filtroPesquisa.lote != '' && this.filtroPesquisa.lote != null){
      filtros['lote'] = this.filtroPesquisa.lote;
    }

    if(salvaPesquisa){
      this.func.salvaFiltroPesquisaAvancada(pagina, 'certificados-nacionais', filtros);
    }


    this.certificadosService.getPaginacao(pagina, this.itensPorPagina, ['mercadoria_listagem', 'cliente'], filtros, ["id_certificado_nacional", "id_mercadoria", "id_cliente", "status_certificado", "numero", "peso", "lote", "data_emissao"], {"numero":"D"})
      .subscribe(data => {
          this.certificados = data['Payload']['data'];
          this.totalItens = data['Payload']['total'];
          this.carregandoTabela = false;
        },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });

  }

  enviaParaCliente(id){

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaEnviarCertificadoCliente'),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){

        $('#menu'+id).addClass('icon-refresh fa-spin').removeClass('icon-menu7');

        self.certificadosService.enviarCertificadoParaCliente(id)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              $('#menu'+id).removeClass('icon-refresh').removeClass('fa-spin').addClass('icon-menu7');
            },
            err => {
              self.func.showErro(err.json());
              $('#menu'+id).removeClass('icon-refresh').removeClass('fa-spin').addClass('icon-menu7');
            });

      });

  }


  alteraStatus(id_solicitacao, id_status, notificaEmail = true){

    let certificadosService = this.certificadosService;
    let text = (notificaEmail) ? this.func.traduzir('front.desejaAlterarStatus') : this.func.traduzir('front.desejaAlterarStatusSemEmail');
    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: text,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true,
      },
      function(){

        $('#menu'+id_solicitacao).addClass('icon-refresh fa-spin').removeClass('icon-menu7');
        certificadosService.setStatus(id_solicitacao, id_status, notificaEmail)
          .subscribe(res => {
              swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.statusAlterado'), "success");
              self.getPage(self.paginaAtual);
            },
            error => {
              swal(self.func.traduzir('front.erro'), self.func.traduzir('front.statusNaoAlterado'), "error");
              self.func.showErro(error.json());
              $('#menu'+id_solicitacao).removeClass('icon-refresh').removeClass('fa-spin').addClass('icon-menu7');
            });

      });
  }

  modalPesquisaAvancada(){
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada(tabela = 'certificados'){

    localStorage.setItem('filtroPesquisa-certificados-nacionais', JSON.stringify(this.filtroPesquisa));

    this.getPage(1, true);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada(){
    this.filtroPesquisa = {"status_pesquisa": "", "data_de":"", "data_ate":"", "numero":"", "numero_analise": "", "id_cliente":"", "id_mercadoria":"", "id_local_ingresso": "", "lote": ""};

    switch (this.router.url.split(/\//).pop()) {
      case 'em-processamento':
        this.filtroPesquisa.status_pesquisa = "1";
        break;
      case 'pronto-emitir':
        this.filtroPesquisa.status_pesquisa = "5";
        break;
      case 'emitidos':
        this.filtroPesquisa.status_pesquisa = "10";
        break;
      default:
        this.filtroPesquisa.status_pesquisa = "";
    }

    localStorage.setItem('filtroPesquisa-certificados-nacionais', JSON.stringify(this.filtroPesquisa));
    this.getPage(1, true);
    this.getPage(1, true);
  }

  solicitaCertificadoEmail(){

  }

  changeSelectCertificado(id_certificado, event){

      if(event.srcElement.checked){
        this.certificadosSelecionados.push(event.target.value);
      }else{
        this.certificadosSelecionados = this.certificadosSelecionados.filter(item => item !== event.target.value);
      }

      console.log(this.certificadosSelecionados);

  }


  emitirSelecionados(){

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaEmitirCertificadosSelecionados'),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true,
      },
      function(){

        $('#menuSelecionar').addClass('icon-refresh fa-spin').removeClass('icon-menu7');


        let certs = self.certificadosSelecionados;

        self.certificadosService.emitirCertificados(certs)
          .subscribe(res => {
              //swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.statusAlterado'), "success");
              self.getPage(self.paginaAtual);
              $('#menuSelecionar').removeClass('icon-refresh').removeClass('fa-spin').addClass('icon-menu7');
            },
            error => {
              self.func.showErro(error.json());
              $('#menuSelecionar').removeClass('icon-refresh').removeClass('fa-spin').addClass('icon-menu7');
            });

      });

  }

  emitirSelecionadosSemNotificar(){

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaEmitirCertificadosSelecionados'),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true,
      },
      function(){

        $('#menuSelecionar').addClass('icon-refresh fa-spin').removeClass('icon-menu7');


        let certs = self.certificadosSelecionados;

        self.certificadosService.emitirCertificadosSemNotificar(certs)
          .subscribe(res => {
              //swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.statusAlterado'), "success");
              self.getPage(self.paginaAtual);
              $('#menuSelecionar').removeClass('icon-refresh').removeClass('fa-spin').addClass('icon-menu7');
            },
            error => {
              self.func.showErro(error.json());
              $('#menuSelecionar').removeClass('icon-refresh').removeClass('fa-spin').addClass('icon-menu7');
            });

      });

  }

  changeCheckAll(e){
    console.log(e);
    console.log(e.target.checked);

    this.checkAll = e.target.checked;

    this.certificadosSelecionados = [];

    if(e.target.checked){
      for(let i in this.certificados){
        this.certificadosSelecionados.push(this.certificados[i].id_certificado_nacional);
      }
    }


  }


  baixarZIP(id_certificado){

    this.certificadosService.baixarZIP(id_certificado)
      .subscribe(json => {
          window.open(this.global.dominio_site+json.Payload,'_blank');
        },
        error => {
          this.func.showErro(error.json());
        });

  }

}



// WEBPACK FOOTER //
// ./src/app/certificados-nacionais/certificados-nacionais.component.ts